import React from 'react';
import { Button } from 'web-library';
import IconWithLabel from 'web-library/stories/atom/IconWithLabel/IconWithLabel';
import { IconName } from 'web-library/stories/atom/Icon/Icon';

interface ImportButtonProps {
  importHandler: any;
  label: string;
  buttonId?: any;
  disabled?: boolean;
}

const ImportButton = (props: ImportButtonProps) => {
  const { importHandler, label, buttonId, disabled } = props;

  return (
    (<Button
                                                                                    onClick={importHandler}
                                                                                    size="medium"
                                                                                    id={`button-${label.replace(/\s/, '-')}-${buttonId}`}
                                                                                    disabled={disabled}
                                                                                  >
      <IconWithLabel
        iconSize="M"
        iconName={IconName.download}
        label={label}
        typographyProps={{
          variant: 'h5',
          align: 'left',
        }}
      />
    </Button>)
  );
};

export default ImportButton;
